import React from "react";
import "./PSF.css";
import { Link } from "react-router-dom";

const PressureSandFilter = () => {
  return (
    <div className="psf-page">
      {/* Hero Section */}
      <section className="hero-psf" style={{background: "url('/images/PSF-3.jpg') center/cover, no-repeat"}}>
        <div className="hero-content">
          <h1>Pressure Sand Filter & Activated Carbon Filter</h1>
          <p>
            Reliable turbidity control and suspended solids removal for crystal‑clear water
            across industrial, commercial, and municipal applications.
          </p>
          <Link to="/contact"><button className="btn-primary">Request a Quote</button></Link>
        </div>
      </section>

      {/* Description */}
      <section className="psf-description">
  <div className="psf-text">
    <h2>Description</h2>
    <p>Crystal Drops offers high quality Pressure Sand Filter by mixing best quality coarse and fine media in right proportions to produce a filter 
      bed with Pore dimensions to support retaining of both large and small suspended particles. These filters are designed to achieve higher flow rate 
      per hour to produce a filtrate with less than 5 ppm (Parts Per Million) for inlet water containing up to 25 ppm suspended solids.  </p>
    <p>
      Our Pressure Sand Filters provide a proven solution for removing turbidity,
      suspended solids, and fine particulates from raw water. Designed with
      precision engineering, they act as a critical pre-treatment stage that
      enhances water clarity, safeguards downstream equipment, and ensures
      compliance with stringent quality standards.
    </p>
  </div>
  <div className="psf-image">
    <img src="/images/ACF-1.jpg" alt="Pressure Sand Filter" className="psf-img" />
  </div>
</section>

      {/* Applications */}
      <section className="psf-applications">
        <h2>Applications</h2>
        <p> The PSF / ACF by Crystal Drops is an abovious choice for all applications where a conventional filter is used.</p>
        <p>It is extensively used in:</p>
        <ul>
          <li>Water and waste water treatment.</li>
          <li>Filtration of clarified water.</li>
          <li>High quality Cation polystyrene resins provide stability and longer life.</li>
        </ul>
        <p>These Filters are available with Mild Steel Rubber lined and Mild Steel Epoxy Painted options and shall be selected based on inlet water characteristics.</p>
      </section>

      {/* Advantages */}
      <section className="psf-advantages">
        <h2>Advantages</h2>
        <ul>
          <li>High efficiency in turbidity removal</li>
          <li>Compact and durable design</li>
          <li>Low maintenance and easy operation</li>
          <li>Customizable flow rates and sizes</li>
          <li>Cost-effective pretreatment solution</li>
          <li>Higher flow rates with lesser space and cost.</li>
          <li>Efficient backwash system.</li>
          <li>Use of raw water for backwash.</li>
        </ul>
      </section>

      {/* Technical Specifications */}
   <section className="psf-tech">
  <h2>Technical Specifications</h2>
  <div className="psf-tech-points">
    <div className="tech-point">
      <h3>Vessel Construction</h3>
      <p>
        Vertical cylindrical vessel made of Mild Steel with dish ends, externally coated with red oxide paint
        and internally lined with anti‑corrosive bituminous paint. Includes pipework, valves, gauges, and
        accessories for complete installation.
      </p>
    </div>
    <div className="tech-point">
      <h3>Size Variants</h3>
      <p>PSF / ACF units available in diameters ranging from 200 mm to 3000 mm.</p>
    </div>
    <div className="tech-point">
      <h3>Carbon Filters</h3>
      <p>Designed for removal of colour, odour, and de‑chlorination of water.</p>
    </div>
  </div>
</section>
    </div>
  );
};

export default PressureSandFilter;